<template>
  <div class="cardlist">
    <!-- 门禁读卡器 -->
    <div class="cardlist-m">
      <el-form
        :inline="true"
        :model="formInline"
        class="demo-form-inline toolbar"
        style="padding-bottom: 0px;"
        @submit.native.prevent
      >
        <el-form-item label="设备编号">
          <el-input
            v-model.trim="formInline.inputdeviceno"
            placeholder="请输入设备编号"
            clearable
            @keyup.enter.native.prevent="enterSearchMember"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"
            icon="el-icon-search"
            plain @click="onSubmit">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button
            type="warning"
            plain
            class="el-icon-plus"
            @click="dialogFormVisible = true"
          >新增</el-button>
        </el-form-item>
      </el-form>
      <div v-loading="loading" element-loading-text="拼命加载中......">
        
        <el-table
          :data="list"
          style="width: 100%"
          :row-style="tableRowStyle"
          :cell-style="{ 'text-align': 'center', 'font-size': '16px' }"
          :header-cell-style="tableHeaderColor"
        >
          <el-table-column label="设备编号" :show-overflow-tooltip="true" align="center">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.deviceNo }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column
                label="设备类型"
                :show-overflow-tooltip="true"
                align="center"
                >
                <template slot-scope="scope">
                    <span style="margin-left: 10px" v-if="scope.row.deviceType===7">门禁读卡器</span>
                </template>
          </el-table-column>-->
          <el-table-column label="设备名称" :show-overflow-tooltip="true" align="center">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.deviceName}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="设备描述"
            style="width: 20%"
            align="center"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.remark}}</span>
            </template>
          </el-table-column>
          <el-table-column label="绑定位置" align="center" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span style="margin-left: 10px;color:orange;" v-if="scope.row.location==null">暂未绑定</span>
              <span style="margin-left: 10px" v-else>{{ scope.row.location}}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="400" align="center">
            <template slot-scope="scope">
             <el-button
                style="margin-right: 5px"
                type="primary"
                size="mini"
                plain
                @click="handleEdit(scope.$index, scope.row)"
                >编辑</el-button
              >
              <el-button
                type="danger"
                size="mini"
                plain
                @click="handleDelete(scope.$index, scope.row)"
                >删除</el-button
              >
              <el-button
                type="info"
                size="mini"
                plain
                @click="gotoPush(scope.$index, scope.row)"
              >出入记录</el-button>
              <el-button
                type="success"
                size="mini"
                v-if="scope.row.status"
                plain
                @click="handleBangdi(scope.$index, scope.row)"
              >绑定</el-button>
              <el-button
                type="primary"
                size="mini"
                v-if="!scope.row.status"
                plain
                @click="handleJiebang(scope.$index, scope.row)"
              >解绑</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          layout="total, prev, pager, next"
          :total="totalDataNumber"
          :page-size="pageSize"
          align="center"
          class="fenye"
        ></el-pagination>
      </div>
      <!-- 弹出新增 -->
      <el-dialog
        title="新增设备信息"
        :visible.sync="dialogFormVisible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        class="cardxz"
        @close="closexz"
      >
        <el-form ref="form" :model="form" :rules="rules">
          <el-form-item label="设备编号" :label-width="formLabelWidth" prop="xzdate">
            <el-input v-model.trim="form.xzdate" placeholder="请输入设备编号"></el-input>
          </el-form-item>
          <el-form-item label="设备名称" :label-width="formLabelWidth" prop="xzname">
            <el-input v-model.trim="form.xzname" placeholder="请输入设备名称"></el-input>
          </el-form-item>
          <el-form-item label="设备描述" :label-width="formLabelWidth" prop="xzsec">
            <el-input v-model.trim="form.xzsec" type="textarea" :rows="3" placeholder="请输入设备描述"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" align="center">
          <el-button @click="cancelxz">取 消</el-button>
          <el-button type="primary" @click="submitForm('form')" :loading="addLoading">确 定</el-button>
        </div>
      </el-dialog>

      <!-- 弹出修改-->
      <el-dialog
        title="修改设备信息"
        :visible.sync="dialogFormEdit"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        class="cardedit"
      >
        <el-form ref="formedit" :model="formedit" :rules="rules">
          <el-form-item label="设备编号" :label-width="formLabelWidth" prop="editdate">
            <el-input disabled v-model.trim="formedit.editdate" auto-complete="off" placeholder="“请输入设备编号"></el-input>
          </el-form-item>
          <el-form-item label="设备名称" :label-width="formLabelWidth" prop="editname">
            <el-input v-model.trim="formedit.editname" auto-complete="off" placeholder="请输入设备名称"></el-input>
          </el-form-item>
          <el-form-item label="设备描述" :label-width="formLabelWidth" prop="editsec">
            <el-input
              v-model.trim="formedit.editsec"
              auto-complete="off"
              type="textarea"
              :rows="3"
              placeholder="请输入设备描述"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" align="center">
          <el-button @click="dialogFormEdit = false">取 消</el-button>
          <el-button type="primary" @click="submitFormEdit('formedit')" :loading="editLoading">确 定</el-button>
        </div>
      </el-dialog>

      <!-- 弹出绑定门禁读卡器位置-->
      <el-dialog
        title="绑定门禁读卡器"
        :visible.sync="dialogFormBangdi"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        class="bangdilocation"
        @close="closeBangdi"
      >
        <el-form ref="formBangdi" :model="formBangdi" :rules="rules">
          <el-form-item label="设备编号 :" :label-width="formLabelWidth">
            <span>{{ formBangdi.bindDeviceNo }}</span>
          </el-form-item>
          <el-form-item label="绑定位置 :" :label-width="formLabelWidth" prop="location">
            <el-input v-model.trim="formBangdi.location" auto-complete="off" style="width:220px;"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" align="center">
          <el-button @click="cancelBangdi">取 消</el-button>
          <el-button type="primary" @click="submitFormBangdi('formBangdi')">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import iTable from "@/components/iTable.vue";
import { baseURL } from "@/utils/request.js";
export default {
  data() {
    return {
      addLoading: false,
      editLoading: false,
      currentPage: 1, //初始页
      pageNum: 1, //页码
      pageSize: 8, //每页显示的条数
      deviceno: "",
      list: [], //返回的结果集合
      totalDataNumber: 0, //数据的总数,
      loading: "", //加载数据中
      location: "", //绑定门禁读卡器位置
      formInline: {
        inputdeviceno: ""
      },
      // options: {
      //     stripe: true, // 是否为斑马纹 table
      //     //loading: true, // 是否添加表格loading加载动画
      //     highlightCurrentRow: true, // 是否支持当前行高亮显示
      //     mutiSelect: false, // 是否支持列表项选中功能
      // }, // table 的参数
      // columns: [
      // {
      //     prop: 'deviceNo',
      //     label: '设备编号',
      //     align: 'center',
      // },
      // {
      //     prop: 'deviceType',
      //     label: '设备类型',
      //     align: 'center',
      //     formatter: (row, column, cellValue) => {
      //     return row.deviceType===7 ? `<span style="white-space: nowrap;color: dodgerblue;">门禁读卡器</span>` : " "
      //     }
      // },
      // {
      //     prop: 'remark',
      //     label: '设备描述',
      //     align: 'center',
      // },
      // {
      //     prop: 'deviceName',
      //     label: '设备名称',
      //     align: 'center',
      // },
      // // //  {
      // // //   prop: 'state',
      // // //   label: '设备描述',
      // // //   align: 'center',
      // // //   render: (h, params) => {
      // // //    return h('el-tag', {
      // // //    props: {type: params.row.state === 0 ? 'success' : params.row.state === 1 ? 'info' : 'danger'} // 组件的props
      // // //    }, params.row.state === 0 ? '上架' : params.row.state === 1 ? '下架' : '审核中')
      // // //   }
      // //  },

      // ], // 需要展示的列
      // operates: {
      //     width: 400,
      //     fixed: 'right',
      //     offset:20,
      //     list: [
      //         {
      //             id:'1',
      //             label: '修改',
      //             type: 'warning',
      //             show: true,
      //             icon: 'el-icon-edit',
      //             plain: false,
      //             disabled: false,
      //             method: (index, row) => {
      //                 this.handleEdit(index, row)
      //         }
      //         },
      //         {
      //             id:'2',
      //             label: '删除',
      //             type: 'danger',
      //             icon: 'el-icon-delete',
      //             show: true,
      //             plain: false,
      //             disabled: false,
      //             method: (index, row) => {
      //                 this.handleDelete(index, row)
      //             }
      //         },
      //         {
      //             id:'3',
      //             label: '出入记录',
      //             type: 'success',
      //             icon: 'el-icon-news',
      //             show: true,
      //             plain: false,
      //             disabled: false,
      //             method: (index, row) => {
      //                 this.handleExitRecord(index, row)
      //             }
      //         },
      //         {
      //             id:'4',
      //             label: '绑定',
      //             type: 'primary',
      //             icon: 'el-icon-good',
      //             show: true,
      //             plain: false,
      //             disabled: false,
      //             method: (index, row,i) => {
      //                 this.handleBangdi(index,row,i)
      //             }
      //         },
      //          {
      //             id:'5',
      //             label: '解绑',
      //             type: 'info',
      //             icon: 'el-icon-good',
      //             show: false,
      //             plain: false,
      //             disabled: false,
      //             method: (index, row) => {
      //                 this.handleJiebang(index, row)
      //             }
      //         },

      //     ]
      // },// 列操作按钮

      //绑定门禁读卡器
      dialogFormBangdi: false,
      formBangdi: {
        location: "",
        bindDeviceNo: "" //绑定模态框弹出的设备编号
      },
      // 新增表单dialog
      dialogFormVisible: false,
      form: {
        xzdate: "",
        xzsec: "",
        xzname: ""
        // xzaddress:'',
      },
      formLabelWidth: "120px",

      //修改表单dialog
      dialogFormEdit: false,
      dialogVisible: false,
      formedit: {
        editdate: "",
        editname: "",
        editsec: ""
        // editaddress:'',
      },

      rules: {
        // 新增正则验证匹配规则
        xzdate: [
          {
            required: true, //是否必填
            message: "不能为空", //规则
            trigger: "blur" //何事件触发
          },
          //可以设置双重验证标准
          //{min: 3, max:25, message: '长度在 3到 25 个字符'},
          // { pattern: /^[A-Za-z0-9_]+$/, message: '请输入由数字、字母、下划线组成的字符' }
          //{ pattern: /^(?=.*?[a-z])(?=.*?[0-9])(?=.*?[_-])[a-z0-9_-]+$/gi, message: '请输入由数字,大小写字母和_或-组成的字符' }
          { min: 1, max: 30, message: "长度在 1到 30 个字符" } //by  guo 2020-4-26-18:12修改
        ],
        xzsec: [
          // {
          //   required: true, //是否必填
          //   message: "不能为空", //规则
          //   trigger: "blur" //何事件触发
          // },
          //可以设置双重验证标准
          { min: 1, max: 100, message: "长度在 1到 100 个字符" }
        ],
        xzname: [
          // {
          //   required: true, //是否必填
          //   message: "不能为空", //规则
          //   trigger: "blur" //何事件触发
          // },
          //可以设置双重验证标准
          { min: 1, max: 30, message: "长度在 1到 30 个字符" }
        ],

        // 修改正则验证匹配规则
        editdate: [
          {
            required: true, //是否必填
            message: "不能为空", //规则
            trigger: "blur" //何事件触发
          },
          //可以设置双重验证标准
          //{ min: 3, max:25,  message: '长度在 3到 25 个字符', },
          // { pattern: /^[A-Za-z0-9_]+$/, message: '请输入由数字、字母、下划线组成的字符' }
          //{ pattern: /^(?=.*?[a-z])(?=.*?[0-9])(?=.*?[_-])[a-z0-9_-]+$/gi, message: '请输入由数字,大小写字母和_或-组成的字符' }
          { min: 1, max: 30, message: "长度在 1到 30 个字符" } //by  guo 2020-4-26-18:12修改
        ],
        editsec: [
          // {
          //   required: true, //是否必填
          //   message: "不能为空", //规则
          //   trigger: "blur" //何事件触发
          // },
          //可以设置双重验证标准
          { min: 1, max: 100, message: "长度在 1到 100 个字符" }
          // { pattern: /^[A-Za-z0-9\u4e00-\u9fa5]+$/, message: '不允许输入空格等特殊符号' }
        ],
        editname: [
          // {
          //   required: true, //是否必填
          //   message: "不能为空", //规则
          //   trigger: "blur" //何事件触发
          // },
          //可以设置双重验证标准
          { min: 1, max: 30, message: "长度在 1到 30 个字符" }
          // { pattern: /^[A-Za-z0-9\u4e00-\u9fa5]+$/, message: '不允许输入空格等特殊符号' }
        ],
        location: [
          {
            required: true, //是否必填
            message: "不能为空", //规则
            trigger: "blur" //何事件触发
          },
          { min: 1, max: 15, message: "长度在 1到 15 个字符" }
        ]
      },
      fileFlag:false,
    };
  },
  methods: {
    //选中行
    handleSelectionChange(val) {
      console.log("val:", val);
    },
    //点击查询
    onSubmit(newVal, oldVal) {
      console.log(newVal, oldVal);
      if (this.formInline.inputdeviceno == "") {
        this.getTableData(this.formInline.inputdeviceno, (this.pageNum = 1));
      } else {
        this.getTableData(
          this.formInline.inputdeviceno,
          (this.pageNum = 1),
          (this.pageSize = 8)
        );
      }
    },
    //键盘事件 按下键盘回车 查询
    enterSearchMember(e) {
      console.log("回车搜索", keyCode, e);
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13 && this.formInline.inputdeviceno != null) {
        if (this.formInline.inputdeviceno == "") {
          this.getTableData(this.formInline.inputdeviceno, (this.pageNum = 1));
        } else {
          this.getTableData(
            this.formInline.inputdeviceno,
            (this.pageNum = 1),
            (this.pageSize = 8)
          );
        }
      }
    },
    // 修改table tr行的背景色
    tableRowStyle({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "background-color: #ffffff";
      } else {
        return "background-color: #e4f5f8";
      }
    },
    // 修改table header的背景色
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "color:#2d2d2d;font-weight: 600; text-align: left;font-size: 16px;background-color: #efefef;";
      }
    },

    //跳转到出入记录页
    gotoPush(index, row) {
      if (row.bind == false) {
        this.$message({
          type: "error",
          message: "该设备还未绑定,请先绑定后再进行操作!"
        });
      } else {
        this.formedit = Object.assign({}, row); //深拷贝数据
        console.log(this.formedit.id);
        var id = this.formedit.id;
        this.$router.push({ path: "/exitrecord", query: { readerId: id } }); //编程式导航跳转  query传参
      }
    },

    //关闭绑定dialog的回调
    closeBangdi() {
      this.$refs.formBangdi.resetFields(); //移除校验结果并重置字段值
    },

    //绑定 取消的dialog
    cancelBangdi() {
      this.dialogFormBangdi = false;
      this.$refs.formBangdi.resetFields(); //移除校验结果并重置字段值
    },

    //解绑
    handleJiebang(index, row) {
      this.$confirm("此操作将解除绑定, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
        closeOnClickModal: false
      }).then(() => {
        this.formedit = Object.assign({}, row); //深拷贝数据
        let deviceId = this.formedit.id;
        this.$postJson("dmc/rfidReader/breakDmcRfidReader/" + deviceId).then(
          res => {
            console.log(res);
            this.$set(this.formedit, "status", true);
            this.getTableData();
            if (res.code != "200") {
              setTimeout(() => {
                this.$message({
                  message: res.message,
                  type: "error"
                });
              }, 300);
            } else {
              setTimeout(() => {
                this.$message({
                  message: res.message,
                  type: "success"
                });
              }, 300);
            }
            this.$refs.formBangdi.resetFields(); //移除校验结果并重置字段值
          }
        );
      });
    },

    //绑定门禁读卡器 弹出模态框
    handleBangdi(index, row) {
      console.log(index, row);
      this.dialogFormBangdi = true;
      this.formBangdi = Object.assign({}, row); //深拷贝数据
      console.log(this.formBangdi.id);
      this.formBangdi.deviceId = this.formBangdi.id;
      this.formBangdi.bindDeviceNo = this.formBangdi.deviceNo;
      // sessionStorage.setItem('status',this.$set(this.list[index], 'status', true))
    },

    //绑定门禁读卡器提交数据
    submitFormBangdi(datainfo) {
      this.$refs[datainfo].validate(valid => {
        if (valid) {
          let param = {
            deviceId: this.formBangdi.deviceId,
            location: this.formBangdi.location
          };
          console.log(param);
          this.$postJson("dmc/rfidReader/bindDmcRfidReader", param).then(
            res => {
              console.log(res);
              this.dialogFormBangdi = false;
              if (res.code == "10061008") {
                setTimeout(() => {
                  this.$message({
                    message: "门禁卡读卡器已经绑定过",
                    type: "error"
                  });
                }, 300);
              } else {
                this.$set(this.formedit, "status", false);
                this.getTableData();
                console.log(this.formedit.status);
                setTimeout(() => {
                  this.$message({
                    message: res.message,
                    type: "success"
                  });
                }, 300);
              }
            }
          );
        }
      });
    },

    //出入记录
    // handleExitRecord(index, row){
    //     console.log(index, row);
    //     this.formedit = Object.assign({}, row);//深拷贝数据
    //     var id=this.formedit.id;
    //     this.$router.push({path:'/exitrecord',query:{id:id}});//编程式导航跳转  query传参
    // },

    //点击弹出修改信息的弹窗
    handleEdit(index, row) {
      (this.dialogFormEdit = true), //打开修改弹窗
        console.log(index, row);
      this.listIndex = index; //记录索引
      console.log(this.listIndex);
      // this.formedit=row;//记录数据
      this.formedit = Object.assign({}, row); //深拷贝记录
      console.log(this.formedit.id);
      //将对应行所对的表格值赋给input框
      this.$set(this.formedit, "editdate", row.deviceNo);
      this.$set(this.formedit, "editsec", row.remark);
      this.$set(this.formedit, "editname", row.deviceName);
    },

    //点击修改弹窗的 确定按钮提交修改的数据
    submitFormEdit(datainfo) {
      //正则匹配规则rules
      this.$refs[datainfo].validate(valid => {
        //判断数据是否存在
        if (valid) {
          let param = {
            id: this.formedit.id,
            remark: this.formedit.editsec,
            deviceName: this.formedit.editname,
            deviceNo: this.formedit.editdate
          };
          console.log(param);
          this.editLoading = true;
          this.$postJson("dmc/rfidReader/edit", param)
            .then(res => {
              console.log(res);
              this.editLoading = false;
              this.dialogFormEdit = false; //关闭修改弹窗
              this.$bus.$emit("submitFormEditchange_cardlist"); //发送一个change事件
              if (res.code == "200") {
                setTimeout(() => {
                  this.$message({
                    message: res.message,
                    type: "success"
                  });
                }, 300);
                console.log("修改成功!");
              } else {
                setTimeout(() => {
                  this.$message({
                    message: res.message,
                    type: "error"
                  });
                }, 300);
                console.log("修改成功!");
              }
              //console.log(this.$store.state.count)
            })
            .catch(res => {
              this.$message({
                type: "error",
                message: res.message
              });
            });
        } else {
          console.log("修改失败!");
          return false;
        }
      });
    },

    //删除
    handleDelete(index, row) {
      if (row.bind == false) {
        this.$confirm("此操作将永久删除该内容, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true,
          closeOnClickModal: false
        })
          .then(() => {
            console.log(index, row);
            let id = row.id;
            console.log(id);
             this.$postJson(`dmc/propertyManagement/untie`,{deviceIds:[id]}).then(res => { // 旧 dmc/rfidReader/deleteById/
             if(res.code ==200){
                this.$bus.$emit("handleDeletechange_cardlist"); //发送一个change事件
              console.log(res);
              this.$message({
                type: "success",
                message: res.message
              });
             }else{
                 this.$message({
                type: "error",
                message: res.message
              });
             }
             
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除"
            });
          });
      } else {
        this.$message({
          type: "error",
          message: "该设备已经被绑定，请先解绑后再进行删除!"
        });
      }
    },

    //关闭新增的dialog
    closexz() {
      this.$refs.form.resetFields(); //移除校验结果并重置字段值
    },

    //点击新增取消  重置表单以及验证
    cancelxz() {
      this.dialogFormVisible = false;
      this.$refs.form.resetFields(); //移除校验结果并重置字段值
    },

    // 新增弹出框点击确定提交信息
    submitForm(datainfo) {
      this.$refs[datainfo].validate(valid => {
        if (valid) {
          let param = {
            remark: this.form.xzsec,
            deviceName: this.form.xzname,
            deviceNo: this.form.xzdate
          };
          console.log(param);
          //this.loading = true
          this.addLoading = true;
          this.$postJson("dmc/propertyManagement/bindDeviceMerchant", param)
            .then(res => {
              //旧： dmc/rfidReader/add
              console.log(res);
              this.addLoading = false;
              this.dialogFormVisible = false;
              this.$refs.form.resetFields(); //移除校验结果并重置字段值
              this.$bus.$emit("submitFormchange_cardlist"); //发送一个change事件
              if (res.code == "200") {
                setTimeout(() => {
                  this.$message({
                    message: res.message,
                    type: "success"
                  });
                }, 300);
                console.log("提交成功!");
              } else {
                setTimeout(() => {
                  this.$message({
                    message: res.message,
                    type: "error"
                  });
                }, 300);
              }
              //console.log(this.$store.state.count)
              //this.loading = false
            })
        } else {
          console.log("提交失败!");
          return false;
        }
      });
    },
    getTableData() {
      let param = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        deviceNo: this.formInline.inputdeviceno,
        location: ""
      };
      console.log(param);
      this.loading = true;
      this.$postJson(
        "dmc/rfidReader/queryGroupRfidReaderListWithPage",
        param
      ).then(res => {
        console.log(res);
        //判断是否有数据
        if (res.result.list.length != 0) {
          this.pageSize = res.result.pageSize;
          this.currentPage = res.result.pageNum;
          this.totalDataNumber = res.result.total * 1;
          this.list = res.result.list;
          //this.$set(this.tableData,res.result.list)
          console.log(this.list);
          res.result.list.forEach((item, index) => {
            console.log(item);
            if (item.bind == true) {
              this.$set(item, "status", false);
            } else if (item.bind == false) {
              this.$set(item, "status", true);
              //item.status=true
            }
          });
          setTimeout(() => {
            this.loading = false;
          }, 500);
        } else {
          this.list = [];
          this.totalDataNumber = 0;
          setTimeout(() => {
            this.loading = false;
          }, 3000);
        }
      });
    },

    //导入
    intoList() {
      this.dialogVisible = true;
    },

    //确认导入
    getUrl(event) {
      let file = event.target.files;
      console.log(file);
      this.fileFlag=true;//by guo 2020-8-4-14:48 添加
      this.formData = new FormData();
      this.formData.append("file", file[0]);
    },

    //确认导入
    intoForm() {
      if(this.fileFlag){
        this.$postFormData(
          "dmc/propertyManagement/merchantToLead",
          this.formData
        ).then(res => {
          this.dialogVisible = false;
           this.formData={};
            this.fileFlag=false;
          if (res.code == 200) {
            this.$message({ message: res.message, type: "success" });
            this.getTableData();
          } else {
            this.$message({ message: res.message, type: "error" });
          }
        });
      }else{
        this.$message({message:'请选择文件',type:'error'})
      }
    },

    closeDialogReset() {
      this.$refs.file.value = ""; // 清空file文件
    },

    //模板下载
    downLoad() {
      window.location.href = baseURL + "dmc/api/downTemplate";
    },

    //初始页currentPage、初始每页数据数pagesize和数据data
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      //改变每页显示的条数
      this.PageSize = val;
      this.getTableData();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageNum = val;
      this.getTableData();
    }
  },

  watch: {
    currentPage(newV, oldV) {
      console.log(newV, oldV);
      deep: true; //深度监听
    },
    tableData(newV, oldV) {
      console.log(newV, oldV);
      deep: true; //深度监听
    },
    data: "onSubmit", //值可以为methods的方法
    operates: {
      handler: function(newVal, oldVal) {
        console.log(newVal, oldVal);
        this.operates = newVal;
      },
      deep: true
    },
    formedit: {
      handler: function(newVal, oldVal) {
        console.log(newVal, oldVal);
        this.formedit = newVal;
      },
      deep: true
    }
  },
  created() {
    // 组件创建完后获取数据，
    // 此时 data 已经被 observed 了
    this.getTableData();
  },
  mounted() {
    //监听submitFormchange事件，如果数据发送变化，就调取getTableData函数重新加载数据。
    this.$bus.$on("submitFormchange_cardlist", () => {
      this.getTableData();
    }),
      //监听handleDeletechange事件，如果数据发送变化，就调取getTableData函数重新加载数据。
      this.$bus.$on("handleDeletechange_cardlist", () => {
        this.getTableData();
      }),
      //监听submitFormEditchange事件，如果数据发送变化，就调取getTableData函数重新加载数据。
      this.$bus.$on("submitFormEditchange_cardlist", () => {
        this.getTableData();
      });
  },
  components: { iTable }
};
</script>
<style lang="scss" scoped>
.cardlist {
  .cardlist-m {
    padding: 10px 0 0 5px;
  }
}
//修改element-ui默认的样式
.del {
  color: red !important;
}
.exitrecord {
  color: green !important;
  margin-right: 10px;
}
.fenye {
  margin: 0;
  padding: 30px 0;
  background: #fff;
}
// ::deep深度作用选择符
::deep .el-dialog__header {
  text-align: left;
  background: rgb(238, 231, 231);
  border-bottom: 2px solid rgb(211, 207, 207);
}
//新增的dialog
@media screen and (min-width: 1200px) {
  ::deep .cardxz .el-dialog {
    width: 30% !important;
  }
}
//修改的dialog
@media screen and (min-width: 1200px) {
  ::deep .cardedit .el-dialog {
    width: 30% !important;
  }
}
//绑定紧急按钮位置和房间的dialog
@media screen and (min-width: 1200px) {
  ::deep .bangdilocation .el-dialog {
    width: 30% !important;
  }
}
@media screen and (min-width: 600px) and (max-width: 1199px) {
  ::deep .bangdilocation .el-dialog {
    width: 55% !important;
  }
}
</style>


